// ✅ Phase 2 — CUSTOMER AVATAR SİSTEMİ
//
// 8 hazır avatar. Backend yalnız `avatarId` saxlayır (avatar_1..avatar_8).
// Heç bir şəkil yüklənmir, heç bir xarici URL saxlanmır — vizual tamamilə
// frontend-də (CSS qradient + ikon) qurulur.

import {
    FaUserAstronaut, FaUserNinja, FaUserSecret, FaUserTie,
    FaCat, FaDragon, FaRobot, FaGhost
} from 'react-icons/fa'

export const AVATARS = [
    { id: 'avatar_1', label: 'Astronavt', Icon: FaUserAstronaut, gradient: 'from-indigo-500 to-blue-600' },
    { id: 'avatar_2', label: 'Ninja',     Icon: FaUserNinja,     gradient: 'from-slate-700 to-slate-900' },
    { id: 'avatar_3', label: 'Agent',     Icon: FaUserSecret,    gradient: 'from-rose-500 to-pink-600' },
    { id: 'avatar_4', label: 'Klassik',   Icon: FaUserTie,       gradient: 'from-amber-500 to-orange-600' },
    { id: 'avatar_5', label: 'Pişik',     Icon: FaCat,           gradient: 'from-fuchsia-500 to-purple-600' },
    { id: 'avatar_6', label: 'Əjdaha',    Icon: FaDragon,        gradient: 'from-emerald-500 to-teal-600' },
    { id: 'avatar_7', label: 'Robot',     Icon: FaRobot,         gradient: 'from-cyan-500 to-sky-600' },
    { id: 'avatar_8', label: 'Kabus',     Icon: FaGhost,         gradient: 'from-violet-500 to-indigo-600' }
]

export const DEFAULT_AVATAR_ID = 'avatar_1'

export const AVATAR_IDS = AVATARS.map(a => a.id)

// avatarId → avatar config (naməlum/boş dəyər üçün fallback avatar_1)
export const getAvatarById = (avatarId) =>
    AVATARS.find(a => a.id === avatarId) || AVATARS[0]

export const isValidAvatarId = (avatarId) => AVATAR_IDS.includes(avatarId)

export default AVATARS
